export const serviceURL = "https://services-k8s-dev.miaid.me/";
